"use client";
import * as React from "react";
const SvgLiveTvSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M16 2.8H9.03L11.42.5 10.9 0 8 2.8 5.09 0l-.51.5 2.4 2.3H0V14h16zm-1.45 9.8H1.45V4.2h13.1zm-8.73-7v5.6l5.09-2.8z" }));
export {
  SvgLiveTvSharp as default
};
